import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=ca134ea6&scoped=true"
var script = {}
import style0 from "./CardList.vue?vue&type=style&index=0&id=ca134ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca134ea6",
  null
  
)

export default component.exports